import { PlatformsApiDatasource } from '../data/datasources/platforms-api.datasource';
import { PlatformsRepositoryImpl } from '../data/repositories/platforms.repository.impl';

const api = new PlatformsApiDatasource();
const repository = new PlatformsRepositoryImpl(api);

export const platformsContainer = { repository };
